export function handlePatientName(patient, socialName = false){
    if(socialName) return patient?.socialName || patient?.user?.name
    return patient?.user?.name || patient?.socialName 
}